module.exports = "/assets/data/e05feb6e9d8e849a00abe729035162d4-AB34.data.json";